import { useCampaignRole } from '../../hooks/useCampaignRole'

interface Props {
  character: {
    is_secret_worshipper: boolean
    secret_deity: string | null
    gm_notes: string | null
    secrets: string | null
    plot_hooks: string | null
    active_conditions: string[]
  }
}

export function SecretsPanel({ character }: Props) {
  const { isGM } = useCampaignRole()

  if (!isGM) return null

  const hasContent = character.is_secret_worshipper || character.gm_notes ||
    character.secrets || character.plot_hooks

  if (!hasContent) return null

  return (
    <div className="border border-danger/30 rounded p-4 mb-4 bg-red-50">
      <h3 className="font-cinzel font-semibold text-sm text-accent uppercase tracking-wider mb-3 pb-2 border-b-2 border-accent/20">GM Secrets</h3>

      {character.is_secret_worshipper && character.secret_deity && (
        <div className="mb-3 p-2 bg-white rounded border border-danger/20">
          <div className="text-sm font-semibold text-danger">Secret Worship</div>
          <div className="text-sm">
            Secretly worships <strong>{character.secret_deity}</strong>
          </div>
        </div>
      )}

      {character.secrets && (
        <div className="mb-2">
          <div className="text-xs font-semibold text-ink-light uppercase mb-0.5">Secrets</div>
          <p className="text-sm">{character.secrets}</p>
        </div>
      )}

      {character.gm_notes && (
        <div className="mb-2">
          <div className="text-xs font-semibold text-ink-light uppercase mb-0.5">GM Notes</div>
          <p className="text-sm whitespace-pre-wrap">{character.gm_notes}</p>
        </div>
      )}

      {character.plot_hooks && (
        <div className="mb-2">
          <div className="text-xs font-semibold text-ink-light uppercase mb-0.5">Plot Hooks</div>
          <p className="text-sm">{character.plot_hooks}</p>
        </div>
      )}
    </div>
  )
}
